
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hairstraightener",
      function () {
        return require("private-next-pages/hairstraightener/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hairstraightener"])
      });
    }
  